export default __webpack_public_path__ + "static-front/media/SendIcon.afb023fc.svg";